import script from "./StepperDescription.vue?vue&type=script&setup=true&lang=js"
export * from "./StepperDescription.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__